(() => {
  const entryUrl = new URL(performance.getEntriesByType('navigation')[0]?.name || location.href);
  const requestedReview = new URL(location.href).searchParams.get('alpe_review') || entryUrl.searchParams.get('alpe_review');
  const openRequestedReview = async () => {
    if (!/^\d+$/.test(requestedReview || '') || !/\/products\/[^/]+\/?$/.test(location.pathname)) return;
    const controller = new AbortController();
    let observer, timer, resize, settleTimer, scheduled = false, done = false, lastCount = -1;
    const stop = () => {
      done = true; controller.abort(); observer?.disconnect(); resize?.disconnect();
      clearTimeout(timer); clearTimeout(settleTimer);
    };
    for (const type of ['wheel', 'touchstart', 'keydown']) document.addEventListener(type, stop, {once: true, passive: true, signal: controller.signal});
    const normalize = text => String(text || '').normalize('NFKC').replace(/\s+/g, ' ').trim();
    const scrollTo = (target, exact) => {
      observer?.disconnect(); clearTimeout(timer);
      const move = behavior => {
        const header = document.querySelector('.rd-header, .site-header');
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 72) - 28);
        window.scrollTo({top, behavior});
      };
      if (exact) {
        target.id = `alpe-review-${requestedReview}`;
        target.classList.add('alpe-review--selected');
        const destination = new URL(location.href);
        destination.searchParams.set('alpe_review', requestedReview); destination.hash = target.id;
        history.replaceState(history.state, '', destination);
      }
      target.tabIndex = -1; target.focus({preventScroll: true});
      move(matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
      resize = new ResizeObserver(() => {if (!done && target.isConnected) move('instant');});
      resize.observe(document.body);
      settleTimer = setTimeout(stop, 2500);
    };
    const fallback = () => {
      const section = document.querySelector('[id$="__alpe_klaviyo_reviews"], #klaviyo-product-reviews-wrapper');
      if (section && !done) scrollTo(section, false); else stop();
    };
    timer = setTimeout(fallback, 30000);
    try {
      const url = new URL('https://fast.a.klaviyo.com/client/reviews/');
      url.search = new URLSearchParams({company_id: 'U33dSk', filter: `and(equals(status,'published'),equals(id,'${requestedReview}'))`});
      const response = await fetch(url, {headers: {revision: '2026-07-15', accept: 'application/vnd.api+json'}, signal: AbortSignal.any([controller.signal, AbortSignal.timeout(12000)])});
      if (!response.ok) throw new Error('Review unavailable');
      const payload = await response.json();
      const review = payload.data?.find(item => String(item.id) === requestedReview)?.attributes;
      if (!review?.product?.external_id) throw new Error('Product review unavailable');
      const author = normalize(typeof review.author === 'string' ? review.author : review.author?.name);
      const content = normalize(review.content), title = normalize(review.title);
      const check = () => {
        scheduled = false;
        if (done) return;
        const root = document.querySelector('#klaviyo-product-reviews-wrapper');
        const product = root?.closest('[data-id]');
        if (!root || !product) return;
        if (String(product.dataset.id) !== String(review.product.external_id)) {stop(); return;}
        const cards = [...root.querySelectorAll('.kl_reviews__review_item')];
        const target = cards.find(card => {
          if (normalize(card.querySelector('.kl_reviews__review__author > div')?.textContent) !== author) return false;
          if (normalize(card.querySelector('.kl_reviews__review__title')?.textContent) !== title) return false;
          const text = normalize(card.querySelector('.kl_reviews__review__content')?.textContent);
          return text === content || (text.length >= 80 && content.startsWith(text.replace(/(?:\.{3}|…)$/, '').trim()));
        });
        if (target) {scrollTo(target, true); return;}
        if (!cards.length || cards.length === lastCount) return;
        const more = root.querySelector('.kl_reviews__load_more_button button');
        if (more && !more.disabled) {lastCount = cards.length; more.click();}
        else if (!more) fallback();
      };
      observer = new MutationObserver(() => {
        if (!scheduled && !done) {scheduled = true; requestAnimationFrame(check);}
      });
      observer.observe(document.body, {childList: true, subtree: true});
      check();
    } catch (error) {if (!done) fallback();}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openRequestedReview, {once: true});
  else openRequestedReview();
  const ROOT_SELECTOR = [
    '[id$="__alpe_klaviyo_reviews"]',
    '#klaviyo-reviews-all',
    '#klaviyo-reviews-summary',
    '#klaviyo-featured-reviews-carousel',
    '#klaviyo-reviews-carousel-wrapper',
    '[class*="kl_reviews"]',
    '[data-klaviyo-reviews]'
  ].join(',');

  const translations = new Map([
    ['Reviews', 'Mnenja'],
    ['Product reviews', 'Mnenja o izdelku'],
    ['Product Reviews', 'Mnenja o izdelku'],
    ['Customer reviews', 'Mnenja kupcev'],
    ['Customer Reviews', 'Mnenja kupcev'],
    ['Write a review', 'Napiši mnenje'],
    ['Write a Review', 'Napiši mnenje'],
    ['Verified buyer', 'Preverjen nakup'],
    ['Verified Buyer', 'Preverjen nakup'],
    ['Most recent', 'Najnovejša'],
    ['Most Recent', 'Najnovejša'],
    ['Most helpful', 'Najbolj koristna'],
    ['Most Helpful', 'Najbolj koristna'],
    ['Most relevant', 'Najbolj relevantna'],
    ['Most Relevant', 'Najbolj relevantna'],
    ['Highest rating', 'Najvišja ocena'],
    ['Highest Rating', 'Najvišja ocena'],
    ['Lowest rating', 'Najnižja ocena'],
    ['Lowest Rating', 'Najnižja ocena'],
    ['Sort by', 'Razvrsti'],
    ['Sort by:', 'Razvrsti:'],
    ['Filter', 'Filtriraj'],
    ['Filter by:', 'Filtriraj:'],
    ['All ratings', 'Vse ocene'],
    ['With photos', 'S fotografijami'],
    ['With videos', 'Z videoposnetki'],
    ['With media', 'S fotografijami ali videom'],
    ['Clear all filters', 'Počisti vse filtre'],
    ['Clear filters', 'Počisti filtre'],
    ['Clear all', 'Počisti vse'],
    ['No matching reviews', 'Ni ustreznih mnenj'],
    ['Try another search, or clear some filters', 'Poskusi drugo iskanje ali počisti filtre'],
    ['Remove filter', 'Odstrani filter'],
    ['Load more', 'Prikaži več'],
    ['Show more', 'Prikaži več'],
    ['Show less', 'Prikaži manj'],
    ['See more', 'Prikaži več'],
    ['See less', 'Prikaži manj'],
    ['Previous', 'Prejšnja'],
    ['Next', 'Naslednja'],
    ['No reviews yet', 'Mnenj še ni'],
    ['Be the first to review this product', 'Bodi prvi, ki napiše mnenje o tem izdelku'],
    ['Search reviews', 'Išči med mnenji'],
    ['Rating', 'Ocena'],
    ['Review', 'Mnenje'],
    ['Review title', 'Naslov mnenja'],
    ['Your review', 'Tvoje mnenje'],
    ['Name', 'Ime'],
    ['Email', 'E-pošta'],
    ['Add a photo', 'Dodaj fotografijo'],
    ['Add photos', 'Dodaj fotografije'],
    ['Submit', 'Pošlji'],
    ['Cancel', 'Prekliči'],
    ['Incentivized', 'Nagrajeno mnenje'],
    ['Incentivized review', 'Nagrajeno mnenje'],
    ['More filters', 'Več filtrov'],
    ['Fewer filters', 'Manj filtrov'],
    ['Less filters', 'Manj filtrov'],
    ['Filters', 'Filtri'],
    ['With photos or videos', 'S fotografijami ali videom'],
    ['Store reply', 'Odgovor trgovine'],
    ['Read more', 'Preberi več'],
    ['Read less', 'Prikaži manj'],
    ['Was this helpful?', 'Je bilo to koristno?'],
    ['Helpful', 'Koristno'],
    ['Questions', 'Vprašanja'],
    ['Ask a question', 'Postavi vprašanje'],
    ['Apply', 'Uporabi'],
    ['Close', 'Zapri']
  ]);

  const reviewNoun = (count) => {
    const remainder = Math.abs(count) % 100;
    if (remainder === 1) return 'mnenje';
    if (remainder === 2) return 'mnenji';
    if (remainder === 3 || remainder === 4) return 'mnenja';
    return 'mnenj';
  };

  const translateValue = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return value;

    if (translations.has(trimmed)) {
      return value.replace(trimmed, translations.get(trimmed));
    }

    let match = trimmed.match(/^Based on (\d+) reviews?$/i);
    if (match) {
      const count = Number(match[1]);
      return `Na podlagi ${count} ${reviewNoun(count)}`;
    }

    match = trimmed.match(/^(\d+) reviews?$/i);
    if (match) {
      const count = Number(match[1]);
      return `${count} ${reviewNoun(count)}`;
    }

    match = trimmed.match(/^Showing (\d+) of (\d+) reviews?$/i);
    if (match) return `Prikazanih ${match[1]} od ${match[2]} mnenj`;

    match = trimmed.match(/^(\d+) stars?$/i);
    if (match) {
      const count = Number(match[1]);
      const noun = count === 1 ? 'zvezdica' : count === 2 ? 'zvezdici' : count < 5 ? 'zvezdice' : 'zvezdic';
      return `${count} ${noun}`;
    }

    match = trimmed.match(/^(\d+) star review$/i);
    if (match) return `Mnenje z oceno ${match[1]} od 5`;

    match = trimmed.match(/^(\d+) reviews? with (\d+) stars?(.*)$/i);
    if (match) {
      const count = Number(match[1]);
      return `${count} ${reviewNoun(count)} z oceno ${match[2]} od 5${match[3]}`.replace(/%%/g, '%');
    }

    match = trimmed.match(/^(\d+) (year|month|day|hour|minute)s? ago$/i);
    if (match) {
      const count = Number(match[1]);
      const forms = {
        year: ['letom', 'letoma', 'leti'],
        month: ['mesecem', 'mesecema', 'meseci'],
        day: ['dnevom', 'dnevoma', 'dnevi'],
        hour: ['uro', 'urama', 'urami'],
        minute: ['minuto', 'minutama', 'minutami']
      };
      const form = forms[match[2].toLowerCase()][count === 1 ? 0 : count === 2 ? 1 : 2];
      return `pred ${count} ${form}`;
    }

    match = trimmed.match(/^Store replied (.+)$/i);
    if (match) return `Odgovor trgovine ${translateValue(match[1])}`;

    match = trimmed.match(/^Average rating is ([\d.]+) stars$/i);
    if (match) return `Povprečna ocena je ${match[1].replace('.', ',')} od 5`;

    if (/^Write a review, opens in a new tab$/i.test(trimmed)) {
      return 'Napiši mnenje, odpre se v novem zavihku';
    }

    return value.replace(/%%/g, '%');
  };

  const localizeRoot = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      if (node.parentElement?.matches('script, style, noscript')) return;
      const translated = translateValue(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    });

    [root, ...root.querySelectorAll('[placeholder], [aria-label], [title]')].forEach((element) => {
      ['placeholder', 'aria-label', 'title'].forEach((attribute) => {
        if (element.hasAttribute(attribute)) {
          const value = element.getAttribute(attribute);
          const translated = translateValue(value);
          if (translated !== value) element.setAttribute(attribute, translated);
        }
      });
    });
  };

  const addReviewAnchor = () => {
    if (document.getElementById('alpe-klaviyo-reviews')) return;

    const section = document.querySelector('[id$="__alpe_klaviyo_reviews"]');
    const widget = document.querySelector('#klaviyo-reviews-all, [data-klaviyo-reviews], [class*="kl_reviews"]');
    const target = section || widget;
    if (!target) return;

    const anchor = document.createElement('span');
    anchor.id = 'alpe-klaviyo-reviews';
    anchor.setAttribute('aria-hidden', 'true');
    target.prepend(anchor);
  };

  const prioritizeFeaturedMedia = () => {
    const scroller = document.querySelector('#klaviyo-reviews-carousel-wrapper .swiper-wrapper');
    if (!scroller || scroller.dataset.alpeMediaOrdered === 'true') return;

    const slides = Array.from(scroller.querySelectorAll(':scope > .swiper-slide'));
    if (slides.length < 2) return;

    const hasReviewMedia = (slide) => {
      if (slide.querySelector('video, [class*="video" i], [class*="play" i], [aria-label*="video" i]')) {
        return true;
      }

      const mediaUrls = Array.from(slide.querySelectorAll('img, source, [style*="background-image"]'))
        .flatMap((element) => [
          element.getAttribute('src'),
          element.getAttribute('srcset'),
          element.getAttribute('style')
        ])
        .filter(Boolean)
        .join(' ');

      return /klaviyo\.s3\.amazonaws\.com\/reviews\/(?:images|videos)\//i.test(mediaUrls);
    };

    const mediaSlides = slides.filter(hasReviewMedia);
    const remainingSlides = slides.filter((slide) => !hasReviewMedia(slide));

    scroller.dataset.alpeMediaOrdered = 'true';
    [...mediaSlides, ...remainingSlides].forEach((slide) => scroller.append(slide));
  };

  const setupFeaturedCarousel = () => {
    const root = document.querySelector('#klaviyo-reviews-carousel-wrapper');
    const scroller = root?.querySelector('.swiper-wrapper');
    const slides = Array.from(root?.querySelectorAll('.swiper-slide') || []);
    const previous = root?.querySelector('.kl_reviews__carousel__prev_button');
    const next = root?.querySelector('.kl_reviews__carousel__next_button');

    if (!root || !scroller || slides.length < 2 || !previous || !next) return;

    root.classList.add('alpe-klaviyo-carousel--paged');
    scroller.setAttribute('tabindex', '0');
    scroller.setAttribute('aria-label', 'Mnenja kolesarjev');

    const updateControls = () => {
      const atStart = scroller.scrollLeft <= 2;
      const atEnd = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2;

      previous.disabled = atStart;
      next.disabled = atEnd;
      previous.classList.toggle('swiper-button-disabled', atStart);
      next.classList.toggle('swiper-button-disabled', atEnd);
      previous.classList.remove('swiper-button-lock');
      next.classList.remove('swiper-button-lock');
    };

    if (root.dataset.alpeCarouselReady !== 'true') {
      const move = (direction, event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        scroller.scrollBy({ left: direction * scroller.clientWidth, behavior: 'smooth' });
      };

      previous.addEventListener('click', (event) => move(-1, event), true);
      next.addEventListener('click', (event) => move(1, event), true);
      scroller.addEventListener('scroll', updateControls, { passive: true });
      scroller.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1, event);
        if (event.key === 'ArrowRight') move(1, event);
      });
      window.addEventListener('resize', updateControls);
      root.dataset.alpeCarouselReady = 'true';
    }

    updateControls();
  };

  let cancelReviewScroll;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-alpe-review-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#alpe-klaviyo-reviews') return;
    addReviewAnchor();
    const anchor = document.getElementById('alpe-klaviyo-reviews');
    if (!anchor) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const section = anchor.parentElement;
    const header = document.querySelector('.rd-header, .site-header');
    const targetTop = () => Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 72) - 24);
    const destination = new URL(location.href);
    destination.hash = url.hash;
    if (location.hash !== url.hash) history.pushState(null, '', destination);
    section.setAttribute('tabindex', '-1');
    section.focus({preventScroll:true});
    cancelReviewScroll?.();
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    if (!motion.matches) {
      const controller = new AbortController();
      let correctionTimer;
      const cancel = () => { controller.abort(); clearTimeout(correctionTimer); };
      cancelReviewScroll = cancel;
      const settle = () => {
        cancel();
        if (anchor.isConnected && Math.abs(window.scrollY - targetTop()) > 8) window.scrollTo({top: targetTop(), behavior: 'smooth'});
      };
      document.addEventListener('scrollend', settle, {once:true, signal:controller.signal});
      for (const type of ['wheel', 'touchstart', 'keydown']) document.addEventListener(type, cancel, {once:true, passive:true, signal:controller.signal});
      correctionTimer = setTimeout(settle, 1600);
    }
    window.scrollTo({top:targetTop(), behavior: motion.matches ? 'instant' : 'smooth'});
  }, true);

  const pending = new Set();
  let frame = 0;
  const queueRoot = (element) => {
    let root = element.closest(ROOT_SELECTOR);
    if (!root) return;
    let parent = root.parentElement?.closest(ROOT_SELECTOR);
    while (parent) {
      root = parent;
      parent = root.parentElement?.closest(ROOT_SELECTOR);
    }
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const roots = [...pending].filter(root => root.isConnected);
      pending.clear();
      if (!roots.length) return;
      addReviewAnchor();
      roots.forEach(localizeRoot);
      if (roots.some(root => root.matches('#klaviyo-reviews-carousel-wrapper') || root.querySelector('#klaviyo-reviews-carousel-wrapper'))) {
        prioritizeFeaturedMedia();
        setupFeaturedCarousel();
      }
    });
  };

  const discover = (node) => {
    if (node.nodeType !== 1) return;
    if (node.closest(ROOT_SELECTOR)) {
      queueRoot(node);
      return;
    }
    node.querySelectorAll(ROOT_SELECTOR).forEach(queueRoot);
  };
  const start = () => discover(document.documentElement);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  new MutationObserver((records) => {
    for (const record of records) {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest(ROOT_SELECTOR)) {
        queueRoot(target);
      } else if (record.type === 'childList') {
        record.addedNodes.forEach(discover);
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'aria-label', 'title']
  });
})();
